var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-layout"},[_c('div',{staticClass:"loading-message"},[_vm._v("提交成功，匹配客服中...")])])}]

export { render, staticRenderFns }